import { RouteObject } from 'react-router-dom';
import { RouteMeta } from '@/pages/routes';

const route: RouteObject = {
	path: 'attendance',
	lazy: async () => ({ Component: (await import('@/modules/attendance/Layout')).default }),
	children: [
		{
			path: '',
			index: true,
			id: 'attendance',
			loader: () => ({
				meta: {
					title: 'Attendance',
					disabled: true,
					htmlTitlePattern: '',
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/attendance/pages/Home')).default }),
		},
		{
			path: 'vacation/calender',
			index: true,
			id: 'vacationCalender',
			loader: () => ({
				meta: {
					title: 'Vacation Calender',
					disabled: true,
					htmlTitlePattern: '',
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/attendance/pages/VacationCalender')).default }),
		},
		{
			path: 'history/:employeeID',
			index: true,
			id: 'employeeHistoryCalender',
			loader: () => ({
				meta: {
					title: 'Employee History Calender',
					disabled: true,
					htmlTitlePattern: '',
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/attendance/pages/EmployeeHistory')).default }),
		},
		{
			path: 'history',
			index: true,
			id: 'attendanceHistory',
			loader: () => ({
				meta: {
					title: 'Attendance History',
					disabled: true,
					htmlTitlePattern: '',
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/attendance/pages/List')).default }),
		},
	],
};
export default route;
